module.exports = __webpack_public_path__ + "static/media/logo.e6694ed5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 777
// module chunks = 0